import { render, staticRenderFns } from "./RemoveLinkedFacilityDialog.vue?vue&type=template&id=2ec923e1"
import script from "./RemoveLinkedFacilityDialog.vue?vue&type=script&lang=js"
export * from "./RemoveLinkedFacilityDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports